export default __webpack_public_path__ + "static/media/block_text.23a801d6.svg";